var React = require('react');

function Bed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M52.797 6.564c-2.129-.05-2.314 1.61-2.198 4.374v8.75h-46.2V2.184C4.398.635 3.758 0 2.2 0 .638 0 0 .636 0 2.185v30.628C-.027 34.862.638 35 2.2 35c1.56 0 2.177-.356 2.197-2.187v-4.377h46.203v4.377c0 1.516.667 2.187 2.197 2.187C54.331 35 55 34.33 55 32.813V8.75c-.002-1.52-.67-2.187-2.203-2.187zm-35.64 10.934c.353.006.492 0 1.103 0h27.936c.919-.073 1.61-.597 1.61-1.076 0-2.698-9.03-5.484-17.008-5.484-8.54 0-15.1 2.786-15.1 5.484.002.48.664.964 1.46 1.076zm-7.08.655c2.085 0 3.784-1.684 3.784-3.756 0-2.077-1.7-3.759-3.784-3.759-2.084 0-3.78 1.68-3.78 3.76 0 2.069 1.696 3.755 3.78 3.755z","fill":"currentColor","fillRule":"nonzero","fillOpacity":"1"}));
}

Bed.defaultProps = {"width":"55","height":"35"};

module.exports = Bed;

Bed.default = Bed;
